import {
  TRUSTED_EMAIL_INPUT_VARIANT_SUCCESS,
  TRUSTED_EMAIL_INPUT_VARIANT_UNVERIFIED,
  TRUSTED_EMAIL_INPUT_VARIANT_ERROR,
  TRUSTED_EMAIL_INPUT_VARIANT_WARNING,
  TRUSTED_EMAIL_INPUT_VARIANT_BLOCKED,
  TRUSTED_EMAIL_INPUT_VARIANT_INFO
} from 'mailup-web-components'

import {
  TRUSTED_SENDER_STATUS_NOT_CONFIRMED,
  TRUSTED_SENDER_STATUS_CONFIRMED,
  TRUSTED_SENDER_STATUS_BLOCKED,
  TRUSTED_SENDER_STATUS_DELIVER_OK,
  TRUSTED_SENDER_STATUS_DELIVER_WARN,
  TRUSTED_SENDER_STATUS_DELIVER_ERROR,
  TRUSTED_SENDER_STATUS_NO_DELIVER,
  TRUSTED_SENDER_STATUS_DELIVER_ISP
} from 'Api/beSendGoApi'
import { evalCondition } from 'mailup-react-helpers'

const mapStatusToVariant = (status, hideDelivStatus, ApplyOverrideDomain) => {
  switch (status) {
    case TRUSTED_SENDER_STATUS_NOT_CONFIRMED:
      return TRUSTED_EMAIL_INPUT_VARIANT_UNVERIFIED
    case TRUSTED_SENDER_STATUS_DELIVER_ERROR:
    case TRUSTED_SENDER_STATUS_DELIVER_ISP:
      if (ApplyOverrideDomain && evalCondition('co:MAILUPSHIELD')) {
        return TRUSTED_EMAIL_INPUT_VARIANT_INFO
      } else {
        return TRUSTED_EMAIL_INPUT_VARIANT_ERROR
      }
    case TRUSTED_SENDER_STATUS_DELIVER_WARN:
      if (ApplyOverrideDomain && evalCondition('co:MAILUPSHIELD')) {
        return TRUSTED_EMAIL_INPUT_VARIANT_INFO
      } else {
        return hideDelivStatus
          ? TRUSTED_EMAIL_INPUT_VARIANT_SUCCESS
          : TRUSTED_EMAIL_INPUT_VARIANT_WARNING
      }
    case TRUSTED_SENDER_STATUS_BLOCKED:
      return TRUSTED_EMAIL_INPUT_VARIANT_BLOCKED
    case TRUSTED_SENDER_STATUS_CONFIRMED:
    case TRUSTED_SENDER_STATUS_DELIVER_OK:
    case TRUSTED_SENDER_STATUS_NO_DELIVER:
      return TRUSTED_EMAIL_INPUT_VARIANT_SUCCESS
  }
}

export default mapStatusToVariant
